// src/components/RootComponent.jsx
import React, { useEffect } from 'react';
import useStore from '../store';
import Main from './Main';
import HistoryGallery from './history/HistoryGallery';

const RootComponent = () => {

  const initTelegram = useStore(state => state.initTelegram);
  const connectSocket = useStore(state => state.connectSocket);
  const loadGameData = useStore(state => state.loadGameData);

  const telegramInitialized = useStore(state => state.telegramInitialized);
  const socketStatus = useStore(state => state.socketStatus);
  const isValid = useStore(state => state.isValid);
  const isHistoryMode = useStore(state => state.isHistoryMode);

  const socket = useStore(state => state.socket);
  const gameInfo = useStore(state => state.gameInfo);
  const applyHistory = useStore(state => state.applyHistory);

  const { ref } = useStore.getState();

  useEffect(() => {
    initTelegram();
  }, [initTelegram]);

  useEffect(() => {
    if (telegramInitialized && !socket?.connected) {
      connectSocket();
    }
  }, [telegramInitialized, socket?.connected, connectSocket]);

  useEffect(() => {
    if (socket?.connected && isValid !== null) {
      if (isValid && !isHistoryMode) {
        loadGameData();
      } else if (!isValid) {
        console.error('Socket connected, but registration has not passed');
      }
    }
  }, [socket, socketStatus, isValid, isHistoryMode, loadGameData]);

  useEffect(() => {
    if (!isHistoryMode && gameInfo && !ref.history.mounted) {
      applyHistory();
    }
  }, [gameInfo, isHistoryMode, applyHistory, ref.history.mounted]);

  const shouldRenderHistory = isHistoryMode && isValid !== false;

  return (
    <div>
      {shouldRenderHistory ? <HistoryGallery /> : <Main />}
    </div>
  );
};

export default RootComponent;
